import { PriceModifierService } from "../../services/PriceModifierService";
import { useApi } from "./useApi";
import { useConfiguration } from "./useConfiguration";

export const usePriceModifiersApi = () => {
    const { executeApiOperation } = useApi();
    const { appConfig } = useConfiguration();

    const priceModifierService = new PriceModifierService(appConfig.apiBaseUrl);

    const findAllPriceModifiers = async (propertyId, filterOptions) => {
        return executeApiOperation(() => priceModifierService.findAll(propertyId, filterOptions));
    };

    const createPriceModifier = async (propertyId, priceModifier) => {
        return executeApiOperation(() => priceModifierService.create(propertyId, priceModifier));
    };

    const updatePriceModifier = async (propertyId, priceModifier) => {
        return executeApiOperation(() => priceModifierService.update(propertyId, priceModifier));
    };

    const deletePriceModifier = async (propertyId, id) => {
        return executeApiOperation(() => priceModifierService.delete(propertyId, id));
    };

    return {
        findAllPriceModifiers,
        createPriceModifier,
        updatePriceModifier,
        deletePriceModifier,
    };
};
